import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";
import { money, pickLang, t } from "@/i18n/booking";

export default function BookingResult() {
  const location = useLocation();
  const lang = pickLang(location.search);
  const params = new URLSearchParams(location.search);
  const code = params.get("code");
  const sessionId = params.get("session_id");
  const [state, setState] = useState(null);

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/public/bookings/${code}/status`, { params: { session_id: sessionId } });
        setState(data);
        if (data.status === "pending_payment" && tries < 20) timer = setTimeout(poll, 2000);
      } catch {
        if (tries < 20) timer = setTimeout(poll, 2000);
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [code, sessionId]);

  const box = (title, body, extra) => (
    <div className="max-w-xl bg-white border border-[#DCD8D0] rounded-xl p-8" data-testid="result-box">
      <h1 className="font-display text-2xl font-bold text-[#1A1A1A] mb-2">{title}</h1>
      <p className="text-[#5C5C5C] mb-4">{body}</p>
      {extra}
    </div>
  );

  return (
    <PublicLayout lang={lang}>
      {() => {
        if (!state || state.status === "pending_payment") return box(t(lang, "result_checking"), t(lang, "pending_body"));
        if (state.status === "pending" || state.status === "active") {
          return box(t(lang, "success_title"), `${t(lang, "success_body")} (${state.code} · ${money(lang, state.signal_amount)})`,
            <Link to={`/reserva/${state.code}`} className="inline-flex rounded-md bg-marca text-white px-4 py-2" data-testid="result-continue">{t(lang, "continue")}</Link>);
        }
        if (state.status === "cancelled" && state.cancel_reason === "abandoned")
          return box(t(lang, "cancel_title"), t(lang, "cancel_body"));
        if (state.status === "cancelled")
          return box(t(lang, "conflict_title"),
            t(lang, state.cancel_reason === "date_conflict_refund_failed" ? "conflict_refund_pending_body" : "conflict_body"));
        return box(t(lang, "expired_title"), t(lang, "expired_body"),
          state.vehicle?.slug && <Link to={`/reservar/${state.vehicle.slug}?lang=${lang}`} className="underline">{t(lang, "retry")}</Link>);
      }}
    </PublicLayout>
  );
}
